var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInquirySuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 342 342"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ADD6FF",
  d: "M13.757 208.861C1.71 171.815-11.56 97.204 22.342 41.603 62.815-24.77 157.96-3.6 185.536 48.383c28.334 53.405 24.25 60.148 80.462 75.495a87.5 87.5 0 0 1 28.388 13.908c43.854 31.969 67.038 104.639 8.95 166.036-69.736 73.71-245.916 39.352-289.579-94.961"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "m281.928 293.597 11.511-34.266s9.723-19.439-14.063-29.418c-23.785-9.979-52.429-10.48-52.429-10.48l-19.694 72.907z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "m138.182 263.432 25.199-49.723s3.946-9.779 11-9.742c0 0 11.137 2.907 6.133 20.569-4.556 16.24-16.887 43.58-26.729 47.872-12.951 5.651-15.603-8.976-15.603-8.976"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M211.163 185.322c12.303-1.486 14.444-14.008 9.742-18.382-4.703-4.375-2.898-13.16-2.898-13.16s2.606-26.356-19.794-24.661c0 0-8.148-7.427-16.568-2.196a76.6 76.6 0 0 1-11.729 6.033c-5.159 1.686-10.763 6.807-5.177 15.493 0 0 3.381 4.201-1.577 7.527-6.024 4.028-6.68 20.834 12.631 28.89 19.512 8.138 18.683.537 18.683.537s2.388 1.632 16.687-.081"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M180.086 179.078s8.202 29.026 3.026 31.542c0 0-6.061 5.176-5.633 7.646.429 2.469 1.75 9.177 1.75 9.177s50.762-17.051 39.689-24.123c-9.305-5.951-16.103-35.452-15.73-40.674z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M194.804 206.036s-9.578 11.328-11.456 17.07c-1.212 3.709-2.97 16.75-4.829 20.468-1.86 3.718-1.641 17.853-1.96 19.084s.301 7.463.301 7.463l18.691-.081 19.977-1.121s9.378 3.053 11.255-13.516c2.534-22.309 3.646-45.375 9.013-47.325 0 0-8.202-2.397-10.617-3.491-6.288-2.816-11.629-5.358-11.629-5.358s-8.165 9.195-18.746 6.807"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M165.331 218.84s-.847 15.401-2.451 20.76-3.764 8.713.127 16.878c3.3 6.917 10.864 13.515 10.864 13.515l18.226.766s-8.202-46.843-9.97-53.824a33.8 33.8 0 0 0-6.753-12.558s-8.74.875-10.043 14.463"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "m215.847 196.549 6.598 7.61s-14.782 9.113-23.33 10.307c0 0-2.115-4.739-2.99-6.225-.291-.501-1.33-1.895-1.33-1.895s21.134-5.869 21.052-9.797"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8F8",
  d: "m215.309 196.038 5.76 6.662s-12.713 8.202-21.179 9.788l-3.555-4.63-1.449-1.64s20.733-6.635 20.423-10.18"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M183.722 198.326s-8.001.456-13.141 5.177a2.248 2.248 0 0 0 .246 3.49c3.901 2.734 11.848 9.66 11.62 19.566 0 0 6.543-18.682 1.275-28.233"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M184.105 197.66s-6.689 1.367-10.499 3.564a1.94 1.94 0 0 0-.953 1.379 1.954 1.954 0 0 0 .47 1.61c3.454 3.882 11.72 14.727 8.631 26.556 0 0 7.664-19.01 2.351-33.109"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDEAE8",
  strokeMiterlimit: 10,
  strokeWidth: 0.52,
  d: "M194.822 208.971s.748 5.112.748 6.908c0 3.791-10.536 2.296-12.522 9.788M182.127 229.421s-3.818 7.929-2.488 14.873 2.78 25.445 2.78 25.445"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M153.466 257.371c-1.504-6.507-3.718-10.498-11.137-23.84-7.418-13.342-13.251-30.412-13.251-30.412l-7.29 3.281s2.515 4.821 8.42 31.633c3.819 17.315 9.068 38.431 23.194 30.821 0 0 2.169-2.287.064-11.483"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M129.334 203.839s0-6.297-5.651-8.904c-5.65-2.606-17.47-3.927-19.302-5.732 0 0-1.987 0-.984 1.923 1.002 1.923 7.564 4.557 9.961 4.711 2.397.155 9.204 3.819 9.387 5.633.182 1.813.583 4.237.583 4.237z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "m115.399 197.059-11.455.091s-3.646-.228-5.14-1.285c-1.495-1.057-4.648-2.615-6.8-2.105 0 0-.91.683.593 1.622s5.468 3.645 5.468 3.645a8.3 8.3 0 0 0 4.275 1.404l14.836-.109z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M115.955 200.285s1.823-9.195-3.554-11.137c0 0-.583 0 0 1.914.584 1.914-.428 9.332-.829 10.581s-.465 4.465 2.925 4.557c3.39.091 8.157-.465 8.111.847l5.195-3.399a6.15 6.15 0 0 0-6.07-3.646c-4.538.274-5.778.283-5.778.283"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "m110.952 197.104 8.895-.957 3.882 4.575-8.102.474zM115.6 201.197s-7.373-1.823-9.023-2.005-3.189-5.268-6.379-6.316c0 0-1.349-.829-.32 1.495a64 64 0 0 0 3.318 6.006s2.288 2.962 3.691 2.907 11.847 1.823 11.847 1.823z"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#7C5653",
  strokeMiterlimit: 10,
  strokeWidth: 0.72,
  d: "M128.049 203.685a6.16 6.16 0 0 0-6.07-3.646c-4.557.255-5.787.265-5.787.265s1.823-9.196-3.554-11.137M111.608 200.04l-4.766-.866a3.33 3.33 0 0 1-2.206-2.224",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7C5653",
  d: "M183.95 195.774s17.316-7.801 17.58-23.695c0 0-7.355 10.353-19.758 13.807z",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M177.489 142.352s-7.801 8.539-7.893 17.014c-.091 8.476-6.224-29.236 7.893-17.014"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M169.578 265.719s-.164 15.229-.811 25.007a296.5 296.5 0 0 0 51.035 3.126s16.76-40.263 14.855-68.779z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "m257.768 277.503-31.486-51.946s-6.762-9.287-2.671-15.785c0 0 9.114-8.639 22.574 6.179 12.367 13.616 34.33 54.416 30.767 60.923-1.704 2.953-19.184.629-19.184.629"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M171.51 149.004c-.956 3.208-1.822 5.222-1.822 12.276s.073 5.468.838 9.113c1.24 5.796 9.806 17.088 14.582 16.724 5.404-.42 11.036-6.216 14.098-10.773s3.226-6.561 3.226-6.561 7.154-22.2-.829-28.726-25.509-7.345-30.093 7.947"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#7C5653",
  strokeMiterlimit: 10,
  strokeWidth: 0.72,
  d: "M180.058 161.28s-.373 6.671-3.216 8.849c-1.048.793.455 1.996 1.758 2.197M177.744 175.643s1.622 1.039 4.839-.346",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7C5653",
  d: "M187.733 163.765c.021-.549-.349-1.007-.827-1.025s-.882.411-.903.959c-.021.549.35 1.008.828 1.026s.882-.412.902-.96M176.037 163.322c.021-.559-.357-1.027-.845-1.045s-.901.42-.922.978.358 1.026.846 1.044c.487.018.9-.419.921-.977",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7C5653",
  strokeMiterlimit: 10,
  strokeWidth: 0.72,
  d: "M183.713 158.692s5.259-.438 7.774.291M171.848 158.838c.082-.848 4.921-1.231 7.09.747",
  opacity: 0.2,
  style: {
    mixBlendMode: "multiply"
  }
}), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M175.064 139.271s.848 8.904 12.714 10.718c15.374 2.351 13.323 16.96 13.323 16.96s10.025-14.518 4.202-24.342c-5.113-8.539-25.91-10.471-30.239-3.336"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M202.004 159.767c.556-1.294 2.87-4.256 5.468-1.604s-.975 10.608-4.666 12.458-1.869-8.357-.802-10.854"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M201.083 163.175s-2.397.72-2.643-2.488-1.913-8.63-7.91-10.17c-5.997-1.541 11.51-6.234 11.51-6.234l.765 4.557zM204.1 169.746a8.895 8.895 0 0 0-3.327 6.306c-.483 6.38 2.005 11.52 8.558 11.848l9.687-6.425.092-11.601z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M169.369 275.681s-8.667.182-9.806.601-.574 1.677 1.768 2.251 7.227-.054 7.227-.054l12.157 3.435s1.659-1.905.31-2.843c-1.349-.939-11.656-3.39-11.656-3.39"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M160.766 283.573a4.75 4.75 0 0 1-4.174-1.75c-.474-.693 5.86-2.032 11.528-3.8 3.226-1.012 13.178 3.089 13.178 3.089l-1.476 3.809-11.437-3.809s-5.651 2.288-7.619 2.461"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M167.765 287.127s-7.993 3.444-11.1.61c0 0 8.201-3.117 9.441-3.818 3.098-1.732 4.611-1.778 6.935-1.258 2.717.429 5.455.715 8.202.857l-.711 4.438s-8.147-2.461-12.767-.829"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M180.751 286.616s-6.434 1.868-8.038 2.497-4.165 4.22-4.666 4.375.957 1.868 2.734.382a13.8 13.8 0 0 1 5.012-2.815c.593-.128 4.748.054 4.748.054z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M179.667 278.414s14.28 4.73 16.249 4.001c4.411-1.65 8.412-.729 8.995 2.369.756 4.038-6.561 8.467-11.628 9.496-5.068 1.03-13.671-3.235-13.671-3.235l-.455-6.379z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCC8A4",
  d: "M205.959 282.762c13.305.255 51.217-13.598 51.445-13.671s17.57-4.93 19.739 4.211c4.43 18.591-25.663 20.505-56.812 20.049-5.76-.082-24.379-2.096-24.379-2.096s-5.468-4.557-2.141-7.883 9.113-.674 12.148-.61"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "m203.526 287.136-43.891-2.069.502 6.525h47.453s-.127-4.456-4.064-4.456"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8F8",
  d: "m165.204 291.501-25.399-59.903a3.136 3.136 0 0 0-3.098-2.87l-93.45-.583a3.126 3.126 0 0 0-3.125 3.472l26.337 54.78c1.495 3.336 4.092 5.122 7.027 5.122z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#D3D5DD",
  d: "M97.109 264.671a5.996 5.996 0 1 0 0-11.993 5.996 5.996 0 0 0 0 11.993"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M177.252 144.384s-2.497-2.069-3.892.383c-1.394 2.451 2.498-5.906 2.498-5.906l2.779 3.837z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8F8",
  d: "M239.478 247.821s-4.219-3.199-6.525 3.445-1.531-20.842-1.531-20.842z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M238.457 246.919s-3.199-4.858-7.418-1.404-13.816 36.19-13.816 36.19l7.801-1.823 9.214-30.183s1.148-3.546 4.219-2.78"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDECEB",
  d: "M275.995 269.684s-5.951-5.177-13.232-4.028c-7.282 1.148-17.653-7.865-18.801-9.97l9.97 14.381s13.807-5.177 22.063-.383"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB414",
  d: "M221.698 200.823s4.802 6.525 12.476 6.717c0 0-7.865 26.274-26.666 30.493z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#212D56",
  d: "M207.317 183.18s3.454 6.133-3.645 11.847-8.631 12.285-6.908 21.872.647 15.356.164 16.404c-1.987 4.129 2.46 14.135 18.381-1.212 11.848-11.391 12.531-34.913-2.241-51.217l-7.483.766z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  stroke: "#212D56",
  strokeMiterlimit: 10,
  strokeWidth: 3.6,
  d: "M340.701 293.47c-1.723.574-291.994.136-291.994.136"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#CFD8DC",
  d: "M207.782 177.155c5.743 0 10.398-5.896 10.398-13.169s-4.655-13.169-10.398-13.169-10.399 5.896-10.399 13.169 4.656 13.169 10.399 13.169"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EBECF0",
  strokeMiterlimit: 10,
  strokeWidth: 1.74,
  d: "M209.367 170.53c2.341 0 4.238-2.929 4.238-6.543s-1.897-6.544-4.238-6.544c-2.34 0-4.237 2.93-4.237 6.544s1.897 6.543 4.237 6.543Z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EBECF0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.74,
  d: "M206.469 150.663s.502-23.103-10.024-22.784"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EBECF0",
  strokeMiterlimit: 10,
  strokeWidth: 1.74,
  d: "M199.078 171.149s-8.138 7.965-15.994 10.125"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBECF0",
  d: "M183.367 183.617c1.646 0 2.98-1.551 2.98-3.463s-1.334-3.464-2.98-3.464-2.98 1.551-2.98 3.464c0 1.912 1.334 3.463 2.98 3.463"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.74,
  d: "M207.782 177.155s.109 24.452 6.807 47.208c16.405 55.865 10.717 90.222-13.752 90.222-21.817 0-39.607-25.098-39.607-25.098"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#213666",
  d: "M318.199 229.439a14.6 14.6 0 0 0-1.166-5.778 31.34 31.34 0 0 0-6.051 27.468l1.822 1.695c3.017-2.843 4.648-6.908 5.286-11 .492-4.111.529-8.265.109-12.385M334.868 240.138a.9.9 0 0 0-.529-.246 13.939 13.939 0 0 0-16.65 10.544 14.6 14.6 0 0 0-.346 3.071l1.239 1.495c2.598.71 5.313-.62 7.482-2.233a26.6 26.6 0 0 0 8.804-11.629 1.08 1.08 0 0 0 0-1.002M294.505 239.537c-2.734-2.26-5.979-4.439-9.533-4.229a1.17 1.17 0 0 0-.993.446c-.383.739 1.012 5.286 1.349 6.106a20.36 20.36 0 0 0 21.152 12.24l1.084-1.704a96 96 0 0 0-13.059-12.859"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "#213666",
  d: "M304.702 253.261c6.198 5.887 6.99 14.582 5.924 22.683-.237 1.759 2.534 1.741 2.734 0 1.167-8.776 0-18.272-6.744-24.606-1.257-1.257-3.217.693-1.914 1.923"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "#213666",
  d: "M310.754 250.473c1.312 7.755-.364 15.593.474 23.376.182 1.749 2.944 1.768 2.734 0-.82-8.038.829-16.095-.556-24.105-.283-1.75-2.953-1.012-2.652.729"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#213666",
  d: "M318.828 249.908c-2.269 3.418-4.556 7.145-5.632 11.146-1.157 4.347-.829 9.241-1.02 13.67-.082 1.823 2.679 1.823 2.734 0 .191-4.211-.119-8.877.911-12.969.957-3.736 3.235-7.29 5.359-10.489 1.039-1.449-1.358-2.834-2.352-1.358"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5768",
  d: "M321.963 292.149h-15.42a1.39 1.39 0 0 1-1.34-1.039l-5.249-19.804a1.394 1.394 0 0 1 .975-1.704 1.7 1.7 0 0 1 .374 0h25.891c.184-.002.366.032.536.1a1.4 1.4 0 0 1 .761.751 1.4 1.4 0 0 1 .061.899l-5.249 19.803a1.41 1.41 0 0 1-1.34.994"
})));
export default SvgInquirySuccess;